//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageComponent from "./ImageComponent.vue";
import LinkButton from "./LinkButton.vue";
export default {
  name: "SingleSocialPost",
  components: { ImageComponent, LinkButton },
  props: {
    block: {
      type: Object,
      required: true,
    },
    post: {
      type: Object,
      required: true,
    },
  },
};
